export const toArrayParam = (value: unknown): string[] => {
	if (Array.isArray(value)) {
		return value
			.map((item) => String(item ?? '').trim())
			.filter(Boolean);
	}

	const normalized = String(value ?? '').trim();
	return normalized ? [normalized] : [];
};
